<template>
  <main>
    <div class="path">
      <i class="el-icon-caret-right"></i>系统设置
      <i class="el-icon-arrow-right"></i>&nbsp;刷新缓存
    </div>

    <section class="content_wrapper">
      <el-button class="search_button" type="primary" icon="el-icon-refresh" @click="reCache">刷新课程缓存</el-button>
      <br>
      <el-button class="search_button" type="primary" icon="el-icon-refresh" @click="reloadWhiteList">刷新白名单价格</el-button>
    </section>


  </main>
</template>

<style>
.el-table .success-cell {
  background: #F0F9EB;
  font-weight: bold;
}
</style>

<script>
import {
  reqReCache,
  reqReloadWhiteList
} from '@/api'

export default {
  name: 'ReCache',

  data() {
    return {
    }
  },

  async mounted() {
  },

  methods: {
    async reCache() {
      const loading = this.$loading({
        lock: true,
        text: '刷新中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      const result = await reqReCache()
      loading.close()

      if (result.code === 0) {
        this.$message({
          message: '刷新成功',
          type: 'success'
        })
      }
    },

    async reloadWhiteList() {
      const loading = this.$loading({
        lock: true,
        text: '刷新中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      const result = await reqReloadWhiteList()
      loading.close()

      if (result.code === 0) {
        this.$message({
          message: '刷新成功',
          type: 'success'
        })
      }
    },

  },

  computed: {}

}
</script>

<style scoped>

main {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.content_wrapper {
  width: 90%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 20px auto;
}

.search_button {
  width: 220px;
  margin-left: 30px;
  height: 40px;
}

.path {
  height: 40px;
  line-height: 40px;
  padding-left: 16px;
  font-size: 14px;
  color: #666;
}

</style>



// WEBPACK FOOTER //
// src/pages/AdminCenter/ReCache/ReCache.vue